{
  "rsvp_requested": "RSVP Requested",
  "prompt": "Are you going?",
  "change": "Change",
  "rsvpd_as": "RSVP'd as {{name}}",
  "going": "Going",
  "not_going": "Not going",
  "notes": {
    "title": "Note",
    "placeholder": "Add a note!",
    "add_note": "Add note",
    "update_note": "Edit",
    "cancel": "Cancel",
    "submit": "Add",
    "remove": "Remove"
  },
  "request_access_title": "Only those invited to this schedule can RSVP"
}
